module.exports = __webpack_public_path__ + "static/media/avatar-circle.b1e3ce37.png";